import { ServiceStore } from "@intrasync/stores";
import { RouteType } from "types/RouteType";

const SafetyComplianceWizardRoute: RouteType = {
  name: "SafetyComplianceWizard",
  path: "/workflows/safety-compliance",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Safety & Compliance Reporting",
      component: () => import("./SafetyComplianceWizardHeader"),
      enableRefreshButton: false,
      enableBackButton: true,
    },
    body: {
      component: () => import("./SafetyComplianceWizard"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    try {
      // Load necessary data for the wizard
      const fieldActivityIssuesStore = rootStore.fieldActivityIssuesStore as ServiceStore;
      const userStore = rootStore.userStore as ServiceStore;
      const documentManagementStore = rootStore.documentManagementStore as ServiceStore;

      await Promise.all([
        fieldActivityIssuesStore?.find(),
        userStore?.find(),
        documentManagementStore?.find(),
      ]);

      return true;
    } catch (error) {
      console.error("Failed to load data for safety compliance:", error);
      return false;
    }
  },
  onExit: ({ rootStore }) => {
    const store = (rootStore as any).safetyComplianceWizardStore;
    store?.reset();
  },
};

export default SafetyComplianceWizardRoute;